import { useState, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import useProfile from "hooks/useProfile";
import useActiveItem from "hooks/useActiveItem";
import GradientBlock from "components/GradientBlock";
import MainContentLeft from "components/main-components/MainContentLeft";
import TournamentBlock from "components/pvp-tournament/TournamentBlock";
import TournamentSelect from "components/pvp-tournament/TournamentSelect";
import TournamentDashboard from "components/pvp-tournament/TournamentDashboard";

const PvpTournaments = () => {
  const { token } = useProfile();
  const { isActiveItem } = useActiveItem();
  const { pathname } = useLocation();

  // Tournament state following crafting pattern exactly
  const [tournamentSlots, setTournamentSlots] = useState([
    { placeholder: "Prediction", value: null },
    { placeholder: "TPC Wager", value: null }
  ]);
  const [activeSlot, setActiveSlot] = useState("Prediction");
  const [selectCards, setSelectCards] = useState([]);

  // Mock data in crafting format
  const mockPredictions = [
    {
      id: 1,
      name: "Longest Drive Winner",
      type: "Prediction",
      image: "/assets/img/placeholder.png",
      properties: [{title: "Event", text: "US Open Golf"}, {title: "Rarity", text: "Rare"}]
    },
    {
      id: 2,
      name: "Total Points Over 220",
      type: "Prediction",
      image: "/assets/img/placeholder.png",
      properties: [{title: "Event", text: "NBA Finals"}, {title: "Rarity", text: "Common"}]
    }
  ];

  const mockTPCs = [
    {
      id: 1,
      name: "10",
      type: "TPC Wager",
      image: "/assets/img/placeholder.png",
      properties: [{title: "Value", text: "$10"}, {title: "Available", text: "5"}]
    },
    {
      id: 2,
      name: "25",
      type: "TPC Wager",
      image: "/assets/img/placeholder.png",
      properties: [{title: "Value", text: "$25"}, {title: "Available", text: "3"}]
    }
  ];

  // Event handlers following crafting pattern
  const clearSlot = (slot) => {
    const newSlots = [...tournamentSlots];
    const slotIndex = newSlots.findIndex(s => s.placeholder === slot.placeholder);
    if (slotIndex >= 0) {
      newSlots[slotIndex].value = null;
      setTournamentSlots(newSlots);
    }
  };

  const selectItemHandler = (item) => {
    const newSlots = [...tournamentSlots];
    const slotIndex = newSlots.findIndex(s => s.placeholder === activeSlot);
    if (slotIndex >= 0) {
      newSlots[slotIndex].value = item;
      setTournamentSlots(newSlots);
    }
  };

  const canJoinTournament = tournamentSlots.every(slot => slot.value !== null);
  const canCreateTournament = tournamentSlots.every(slot => slot.value !== null);

  // Set inventory items based on active slot
  useLayoutEffect(() => {
    if (activeSlot === "Prediction") {
      setSelectCards(mockPredictions);
    } else if (activeSlot === "TPC Wager") {
      setSelectCards(mockTPCs);
    }
  }, [activeSlot]);

  return (
    <>
      <GradientBlock>
        <h1 className='gradient-block__title'>PVP Tournaments</h1>
      </GradientBlock>
      <main className="main-content">
        <MainContentLeft
          getOpenedClass={() => 'opened'}
          filters={null}
          setOffsetCount={() => {}}
          tournamentSlots={tournamentSlots}
        />
        <div className="main-content__right">
          <div className="tournament-upper-section">
            <TournamentBlock
              tournamentSlots={tournamentSlots}
              activeSlot={activeSlot}
              setActiveSlot={setActiveSlot}
              clearSlot={clearSlot}
              canJoinTournament={canJoinTournament}
              canCreateTournament={canCreateTournament}
            />
            <div className="tournament-background-panel">
              <TournamentDashboard />
            </div>
          </div>
          <TournamentSelect
            items={selectCards}
            activeSlot={activeSlot}
            selectItemHandler={selectItemHandler}
          />
        </div>
      </main>
    </>
  );
};

export default PvpTournaments;
